import { SelectItem } from 'primeng/api';
import { SupplierRiskManagementServiceType } from '../../enums/supplier-risk-management/supplier-risk-management-service-type.enum';
import { AMPriorityEnum } from '../../enums/am-priority.enum';
import { OrganisationContractTypes } from '../../enums/organisation-contract-types.enum';

/**
 * Filter options shared by every view on the supplier risk management page. These are fixed lists
 * rather than lookups from the API, so they live here to keep the risks view and the unscheduled
 * tasks view offering the same choices under the same labels.
 */

/**
 * Only the contract types risk management deals with. Employee and Project suppliers are excluded
 * from these views server-side, so they are deliberately absent.
 */
export const SUPPLIER_CONTRACT_TYPE_OPTIONS: SelectItem[] = [
  { value: OrganisationContractTypes.SelfEmployed, label: 'Self-Employed' },
  { value: OrganisationContractTypes.Contracted, label: 'Contracted' },
  { value: OrganisationContractTypes.Backstop, label: 'Backstop' },
];

export const CUSTOMER_PRIORITY_OPTIONS: SelectItem[] = [
  { value: AMPriorityEnum.Unset, label: 'Unset Priority' },
  { value: AMPriorityEnum.W1, label: 'W1 Critical Priority' },
  { value: AMPriorityEnum.W2, label: 'W2 High Priority' },
  { value: AMPriorityEnum.W3, label: 'W3 Medium Priority' },
  { value: AMPriorityEnum.W4, label: 'W4 Low Priority' },
];

export const SERVICE_TYPE_OPTIONS: SelectItem[] = [
  { value: SupplierRiskManagementServiceType.Driven, label: 'Driven' },
  { value: SupplierRiskManagementServiceType.Transported, label: 'Transported' },
  { value: SupplierRiskManagementServiceType.Recovery, label: 'Recovery' },
];

/**
 * Driven work is the default on every view: it is the bulk of the movements risk management
 * chases. Returned as a new array each time so a form cannot mutate the shared default.
 */
export const defaultServiceTypes = (): SupplierRiskManagementServiceType[] => [
  SupplierRiskManagementServiceType.Driven,
];
